import {
	ADDRESS_COMPONENT_ELEMENT_ID,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { CountrySelect } from '@dealstack/frontend/shared/components/forms/CountrySelect/CountrySelect';
import { StringInput } from '@dealstack/frontend/shared/components/forms/StringInput/StringInput';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { EMPTY_CALLBACK } from '@dealstack/shared/lib/utils';
import { Flex } from '@mantine/core';
import styled from 'styled-components';

interface Props {
	countryFieldName: string;
	cityFieldName: string;
	postCodeFieldName: string;
	streetFieldName: string;
	houseNumberFieldName: string;
	disabled?: boolean;
}

export const AddressInput = ({
	countryFieldName,
	cityFieldName,
	postCodeFieldName,
	streetFieldName,
	houseNumberFieldName,
	disabled,
}: Props) => {
	const tInvestor = useTranslationInvestor();

	return (
		<Flex direction="column" gap="1em">
			<Row>
				<UIElementIdentifier
					identifier={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_COUNTRY}
				>
					<CountrySelect
						onInputChange={EMPTY_CALLBACK}
						size="s"
						name={countryFieldName}
						disabled={disabled}
						label="COUNTRY"
					/>
				</UIElementIdentifier>
				<UIElementIdentifier
					identifier={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_CITY}
				>
					<StringInput
						label={tInvestor(
							'investment.personal_details.personal_information_form.city'
						)}
						name={cityFieldName}
						disabled={disabled}
					/>
				</UIElementIdentifier>
			</Row>

			<ThreeItemRow>
				<UIElementIdentifier
					identifier={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_STREET}
				>
					<StringInput
						label={tInvestor(
							'investment.personal_details.personal_information_form.street'
						)}
						name={streetFieldName}
						disabled={disabled}
					/>
				</UIElementIdentifier>
				<UIElementIdentifier
					identifier={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_HOUSE_NUMBER}
				>
					<StringInput
						label={tInvestor(
							'investment.personal_details.personal_information_form.house_number'
						)}
						name={houseNumberFieldName}
						disabled={disabled}
					/>
				</UIElementIdentifier>
				<UIElementIdentifier
					identifier={ADDRESS_COMPONENT_ELEMENT_ID.INVESTOR_ADDRESS_POST_CODE}
				>
					<StringInput
						label={tInvestor(
							'investment.personal_details.personal_information_form.postal_code'
						)}
						name={postCodeFieldName}
						disabled={disabled}
					/>
				</UIElementIdentifier>
			</ThreeItemRow>
		</Flex>
	);
};

const Row = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 1em;
	align-items: end;
	${CountrySelect} {
		input {
			border-color: ${({ theme }) => theme.v2.color.neutral[500]};
		}

		&:focus {
			border: ${({ theme }) => theme.v2.color.neutral[700]};
		}
	}
`;

const ThreeItemRow = styled(Row)`
	grid-template-columns: 1fr 0.54fr 0.4fr;
`;
